import React from 'react'
import propTypes from 'prop-types'
import map from 'lodash/map'
import classNames from 'classnames'
import { Fragment, useState } from 'react'
import { Listbox as LessListbox, Transition } from '@headlessui/react'
import { FaCheck, FaChevronDown } from 'react-icons/fa'

import Loader from 'components/Loader'
import { usePrevious } from 'react-use'


export default function Listbox(props) {
  const [selected, setSelected] = useState(props.defaultValue)
  const prevSelected = usePrevious(selected)

  const value = props.value
  const prevValue = usePrevious(value)

  React.useEffect(() => {
    if (value === null && prevValue !== null) {
      setSelected(props.defaultValue)
    }
    if (value?.value !== undefined && prevValue?.value !== undefined && value?.value !== prevValue?.value) {
      setSelected(value)
    }
  }, [value]) // eslint-disable-line

  React.useEffect(() => {
    if (selected?.value !== prevSelected?.value) {
      props?.onChange(selected)
    }
  }, [selected]) // eslint-disable-line

  return (
    <LessListbox value={selected} onChange={setSelected}>
      <div className='relative mt-1'>
        <LessListbox.Button className='
          relative placeholder-gray-400 text-gray-700 bg-white
          focus:outline-none focus:ring ring-primary-600
          border-0 p-4 pr-10 rounded shadow w-full text-sm
        '>
          <span className='block truncate text-left'>{selected.label}</span>
          <span className='absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none'>
            {
              ! props.loading ? (
                <FaChevronDown
                  className='w-4 h-4'
                  aria-hidden='true'
                />
              ) : (
                <Loader active />
              )
            }
          </span>
        </LessListbox.Button>
        <Transition
          as={Fragment}
          leave='transition ease-in duration-100'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <LessListbox.Options className='
            absolute rounded-md shadow-lg
            w-full py-1 mt-1 max-h-60
            overflow-auto
            text-base z-20
            bg-white ring-1 ring-black ring-opacity-5
            focus:outline-none sm:text-sm
          '>
            {
              map(
                props.options,
                option => (
                  <LessListbox.Option
                    key={`listbox_${option.value}`}
                    className={({ active }) =>
                      classNames(
                        'cursor-default select-none relative py-2 pl-10 pr-4',
                        'hover:bg-primary-600 hover:text-white transition-all',
                      )
                    }
                    value={option}
                  >
                    {() => {
                      const _selected = selected?.value !== null && selected?.value === option?.value
                      return (
                        <>
                          <span className={classNames(
                            {
                              'font-medium': _selected,
                            },
                            'block truncate',
                          )}>
                            {option.label}
                          </span>
                          {
                            _selected && (
                              <span className={classNames(
                                'absolute inset-y-0 left-0 flex items-center pl-3',
                              )}>
                                <FaCheck className='w-3 h-3' aria-hidden='true' />
                              </span>
                            )
                          }
                        </>
                      )
                    }}
                  </LessListbox.Option>
                )
              )
            }
          </LessListbox.Options>
        </Transition>
      </div>
    </LessListbox>
  )
}


Listbox.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    label: propTypes.any.isRequired,
    value: propTypes.any.isRequired,
  })).isRequired,
  defaultValue: propTypes.object,
  loading: propTypes.bool,
  onChange: propTypes.func,
}

Listbox.defaultProps = {
  defaultValue: {},
  loading: false,
  onChange: () => {},
}
